import { configureStore, combineReducers } from '@reduxjs/toolkit';
// import AuthSlice from 'pages/LoginPage/slices';
// import HomeSlice from 'pages/Dashboard/slices';
import ShopListSlice from 'app/components/MatxLayout/Layout1/slices';
import SalesSlice from 'app/views/Home/Sales/slices';

const reducer = {
  // containers: combineReducers({ auth: AuthSlice }),
  // home: HomeSlice,
  shopList: ShopListSlice,
  sales: SalesSlice,
};

export default configureStore({
  reducer: reducer,
});
